import { ofType } from "redux-observable";
import { map, mergeMap, flatMap } from "rxjs/operators";
import { from } from "rxjs";
import {
  SETSELECTED,
  SETPATIENTSELECTED,
  SET as PATIENTSET,
  RESET as PATIENTRESET,
} from "one-state-subject/src/types";

import { setAction as setReferralsAction } from "one-state-pending-referrals/src/actions";

import { TransformResponse as TransformReferrals } from "../../pendingreferrals/src/transform";
import { TransformResponse as TransformPcp } from "../../pcp/src/transform";
import { TransformResponse as TransformPharmacies } from "../../pharmacies/src/transform";
import { TransformResponse as TransformAllergies } from "../../activeallergies/src/transform";
import { TransformResponse as TransformProblems } from "../../activeproblems/src/transform";
import { TransformResponse as TransformMedicalHistory } from "../../medicalhistory/src/transform";
import { TransformResponse as TransformMedication } from "../../medication/src/transform";
import { TransformInsuranceDetails } from "../../insurance/src/transform";

import { setAction as setSkeletonAction } from "one-state-skeleton";
import { setAction as setPcpAction} from 'one-state-pcp/src/actions';
import { setAction as setPharmacyAction } from 'one-state-patient-pharmacy/src/action';
import { setAction as setAllergyAction } from 'one-state-activeallergies/src/actions';
import { setAction as setProblemAction } from 'one-state-activeproblems/src/actions';
import { setAction as setMedicalHistoryAction } from 'one-state-medicalhistory/src/actions';
import { setAction as setMedicationAction } from 'one-state-medication/src/actions';
import { setAction as setInsuranceAction } from 'one-state-insurance';

import { Skeleton } from "one-model-local";

import { setSelectedPatient } from "one-state-appointments";

import { addAction } from "one-state-error/src/actions";

import { ErrorObject } from "one-state-error/src/errorobject";
import {
  format,
  substract_daysoncurrentdate,
  add_daysoncurrentdate,
} from "one-util-date";
import { Disposition } from 'one-model-local';
export const enum Types {
  SETAPPOINTMENTS = "set-appointments/set",
  SETAPPOINTMENTSSUCCESS = "set-appointments-success",
  CANCELAPPT = "one-state-appointments/cancel-appt",
  SETCANCELAPPT = "one-state-appointments/push-cancel-appt",
  STORE_DISPOSITION_CODE = "store-disposition-code",
}

const setAppointments = (payload: any) => ({
  type: Types.SETAPPOINTMENTS,
  payload,
});

const pushToSkeleton = (payload: any) => setSkeletonAction(payload);
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });

/**
 * This Fuction will fetch the data of upcoming appts
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */

export const fetchDashboardApi = (context: any) => (action$: any, state$: any) => {
  const errorTime = format(new Date(), "LT");
  const errorDate = format(new Date(), "LL");
  const {
    serverone,
    log,
    agentId,
    teamName,
    settings: {
      compatible,
      epicendpoints: { consolidated_api_two, patientappointment, apitoken },
      uisettings: {
        dashboardapiconfig: {
          patientappointment: patientappointmentApi,
          getpendingreferrals: getpendingreferralsApi,
          getpharmacy : getpharmacyApi,
          activeallergies : activeallergiesApi,
          activeproblems : activeproblemsApi,
          medicalhistory : medicalhistoryApi,
          getbillingdetails : getbillingdetailsApi,
          medication : medicationApi,
          insurance : insuranceApi,
        },
      },
      appointment_config: { past_appointment_days, future_appointment_days },
    },
  } = context;
  const { contact_center_type } = compatible;
  
  return action$.pipe(
    ofType(SETPATIENTSELECTED, Types.SETAPPOINTMENTSSUCCESS),
    //todo: to fix the type of Action
    mergeMap((action: any) => {
      /**
       * @param dataresponse contains the patient response
       */
      let dataresponse: any = action.payload;
      log.debug("one-epics", "fetch Appointments request", dataresponse);
      const getRequest = (datares: any) => {
        if (datares?.id) {
          let headers = new Headers();

          // todo need to refractor to include authorization in interface
          headers.set("Authorization", "Basic " + apitoken?.token);

          let startdate = substract_daysoncurrentdate(
            past_appointment_days,
            "DD-MM-YYYY"
          );
          let enddate = add_daysoncurrentdate(
            future_appointment_days,
            "DD-MM-YYYY"
          );
          const data = {
            PatientID: datares?.id,
            //"PatientID": "E5555",
            //Mirth is taking care of Start and End Date
            StartDate: startdate,
            EndDate: enddate,
          };
          /**
           * Here we invoke epic_dashboard API. 
           * This will be invoke if consolidated_api_invocation is set to true in settings.json
           */
          const response = serverone
            .get({
              path: `${consolidated_api_two}?patient_id=${datares?.id}&start_date=${startdate}&end_date=${enddate}`,
              headers: headers,
            })
            .then((responsefound: any) => responsefound)
            .catch((responseresult: any) => {
              console.log("Error occured:", responseresult);
              log.error("ccw-gadget,fetchDashboardApi-epic", "fetch-fetchDashboardApi-epic", {
                responseresult,
              });
              /**
               * Creating the error object for epic_dashboard API in case of failure scenarios.
               */
              let errorbuild: ErrorObject = {
                source: "epic_dashboard",
                type: "error",
                status: responseresult?.status,
                erroritems: responseresult?.errors,
                error_date: errorDate,
                error_time: errorTime,
              };
              return errorbuild;
            });
          log.debug("one-epics", "fetch fetchDashboardApi response", response);
          return from(response);
        } else {
          return from([]);
        }
      };

      return getRequest(dataresponse).pipe(
        flatMap((response: any) => {
          //Setting Selected Patient Object to store in Redux
          const actions: any = [setSelectedPatient(dataresponse?.id)];
          /**
           * dashboardResponse conatins epic_dashboard response
           */
          const dashboardResponse = response && response?.output && response?.output?.results && response?.output?.results?.length > 0 ? response?.output?.results[0] : {}
          // Fetch Appointments
          if (patientappointmentApi) {
            const appointmentResponse = dashboardResponse.getpatientappointment;
            if (appointmentResponse) {
              actions.push(setAppointments(appointmentResponse));
            }
            let skeletonupcomingappts: Skeleton = {
              upcomingAppts_skeleton: false
            }
            actions.push(pushToSkeleton(skeletonupcomingappts));
          }

          // Fetch Pending Referrals
          if (getpendingreferralsApi) {
            const referralResponse = TransformReferrals(
              dashboardResponse.getpatientreferrals,
              context
            );
            if (referralResponse) {
              actions.push(setReferralsAction(referralResponse.referrals));
              if (referralResponse.error){
                actions.push(addAction(referralResponse.error));
              }
            }
            let skeletonpendingreferrals: Skeleton = {
              pendingReferrals_skeleton: false,
            };
            actions.push(pushToSkeleton(skeletonpendingreferrals));
          }

          // Fetch Pcp
          const pcpResponse = TransformPcp(dashboardResponse.get_pcp, context);
          
          if (pcpResponse) {
            actions.push(setPcpAction(pcpResponse.pcp));
            if(pcpResponse.error){
              actions.push(addAction(pcpResponse.error));
            }
          }
          let skeletonPatientCare: Skeleton = {
            pendingCare_skeleton: false
          }
          actions.push(pushToSkeleton(skeletonPatientCare));

          // Fetch Pharmacies
          if (getpharmacyApi) {
            const pharmacyResponse = TransformPharmacies(
              dashboardResponse.getpreferredandrecentpharmacies,
              context
            );

            if (pharmacyResponse) {
              actions.push(setPharmacyAction(pharmacyResponse.pdata));
              if(pharmacyResponse.error){
                actions.push(addAction(pharmacyResponse.error));
              }
            }
            let skeletonPharmacy: Skeleton = {
              pharmacies_skeleton: false
            }
            actions.push(pushToSkeleton(skeletonPharmacy));
          }

          // Fetch Active Allergies
          if (activeallergiesApi) {
            const allergyResponse = TransformAllergies(
              dashboardResponse.getactiveallergies,
              context
            );

            if (allergyResponse) {
              actions.push(setAllergyAction(allergyResponse.allergies));
              if(allergyResponse.error){
                actions.push(addAction(allergyResponse.error));
              }
            }
          }

          // Fetch Active Problems
          if (activeproblemsApi) {
            const problemResponse = TransformProblems(
              dashboardResponse.getactiveproblemlist,
              context
            );

            if (problemResponse) {
              actions.push(setProblemAction(problemResponse.activeproblems));
              if(problemResponse.error){
                actions.push(addAction(problemResponse.error));
              }
            }
          }

          // Fetch Medical History
          if (medicalhistoryApi) {
            const medicalHistoryResponse = TransformMedicalHistory(
              dashboardResponse.getmedicalhistory,
              context
            );

            if (medicalHistoryResponse) {
              actions.push(setMedicalHistoryAction(medicalHistoryResponse.medicalhistory));
              if(medicalHistoryResponse.error){
                actions.push(addAction(medicalHistoryResponse.error));
              }
            }
          }

          // Fetch Billing Details
          if (getbillingdetailsApi) {
            const billingDetailsResponse = dashboardResponse.getpatientbillingdetails;
            if (billingDetailsResponse) {
              actions.push({
                type: 'set-billing/set',
                payload: billingDetailsResponse,
              })
            }
          }

          // Fetch Medications
          if (medicationApi) {
            const medicationResponse = TransformMedication(
              dashboardResponse.getmedication,
              context
            );

            if (medicationResponse) {
              actions.push(setMedicationAction(medicationResponse.medication));
              if(medicationResponse.error){
                actions.push(addAction(medicationResponse.error));
              }
            }
          }

          // Fetch Insurance Details
          if (insuranceApi) {
            const insuranceResponse = TransformInsuranceDetails(
              dashboardResponse.getcoveragebuckets,
              context
            );
            if (insuranceResponse) {
              actions.push(setInsuranceAction(insuranceResponse.insurancedata));
              if(insuranceResponse.error){
                actions.push(addAction(insuranceResponse.error));
              }
            }
            let skeletoninsurance: Skeleton = {
              insurance_skeleton: false
            }
            actions.push(pushToSkeleton(skeletoninsurance));
          }

          // check for error messages.
          if (response && (response.status >= 400 || response.type == "error")) {
            actions.push(addAction(response));
          }

          //Disposition Framework
          if (response && response?.status == 200) {
            // Success Dispostion
            let disp: Disposition = { value: "173" }
            if (contact_center_type && contact_center_type === 'five9') {
              let agentIdValue = sessionStorage.getItem("agentName");
              let skillName = sessionStorage.getItem("skillName");
              disp.meta00 = agentIdValue;
              disp.meta01 = skillName;
              disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
            } else {
              disp.meta00 = agentId;
              disp.meta01 = teamName;
              disp.dial_list_uid = state$.value.choosecaller?.callId;
            }
            disp.meta02 = dataresponse?.id;
            disp.meta03 = response?.status;
            disp.meta04 = 'client';
            actions.push(pushToDisposition(disp));
          } else {
            // Partial/Failure Scenario Dispostion
            let disp: Disposition = { value: "976" }
            if (contact_center_type && contact_center_type === 'five9') {
              let agentIdValue = sessionStorage.getItem("agentName");
              let skillName = sessionStorage.getItem("skillName");
              disp.meta00 = agentIdValue;
              disp.meta01 = skillName;
              disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
            } else {
              disp.meta00 = agentId;
              disp.meta01 = teamName;
              disp.dial_list_uid = state$.value.choosecaller?.callId;
            }
            disp.meta02 = dataresponse?.id;
            disp.meta03 = response?.status;
            disp.meta04 = 'client';
            actions.push(pushToDisposition(disp));
          }
          /**
           * Retreiving sub-api responses from caller_lookup response
           */
          response?.output?.progress?.map(
            (e: any) => {
              let value = e?.split(":");
              let statusvalue = e?.split(" ");
              let statuscode = value[1]?.replace(/\s/g, "");
              if(value && value?.length > 0 && value[0].includes('getpatientappointment')){
                if (statuscode !== "true200") {
                    let disp: Disposition = { value: "977" }
                    if (contact_center_type && contact_center_type === 'five9') {
                        let agentIdValue = sessionStorage.getItem("agentName");
                        let skillName = sessionStorage.getItem("skillName");
                        disp.meta00 = agentIdValue;
                        disp.meta01 = skillName;
                        disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                    } else {
                        disp.meta00 = agentId;
                        disp.meta01 = teamName;
                        disp.dial_list_uid = state$.value.choosecaller?.callId;
                    }
                    disp.meta02 = statusvalue[1];
                    disp.meta03 = 'client';
                    actions.push(pushToDisposition(disp));
                }
              }

              if(value && value?.length > 0 && value[0].includes('getpatientreferrals')){
                if (statuscode !== "true200") {
                    let disp: Disposition = { value: "978" }
                    if (contact_center_type && contact_center_type === 'five9') {
                        let agentIdValue = sessionStorage.getItem("agentName");
                        let skillName = sessionStorage.getItem("skillName");
                        disp.meta00 = agentIdValue;
                        disp.meta01 = skillName;
                        disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                    } else {
                        disp.meta00 = agentId;
                        disp.meta01 = teamName;
                        disp.dial_list_uid = state$.value.choosecaller?.callId;
                    }
                    disp.meta02 = statusvalue[1];
                    disp.meta03 = 'client';
                    actions.push(pushToDisposition(disp));
                }
              }

              if(value && value?.length > 0 && value[0].includes('get_pcp')){
                if (statuscode !== "true200") {
                    let disp: Disposition = { value: "979" }
                    if (contact_center_type && contact_center_type === 'five9') {
                        let agentIdValue = sessionStorage.getItem("agentName");
                        let skillName = sessionStorage.getItem("skillName");
                        disp.meta00 = agentIdValue;
                        disp.meta01 = skillName;
                        disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                    } else {
                        disp.meta00 = agentId;
                        disp.meta01 = teamName;
                        disp.dial_list_uid = state$.value.choosecaller?.callId;
                    }
                    disp.meta02 = statusvalue[1];
                    disp.meta03 = 'client';
                    actions.push(pushToDisposition(disp));
                }
              }

              if(value && value?.length > 0 && value[0].includes('getpreferredandrecentpharmacies')){
                if (statuscode !== "true200") {
                    let disp: Disposition = { value: "980" }
                    if (contact_center_type && contact_center_type === 'five9') {
                        let agentIdValue = sessionStorage.getItem("agentName");
                        let skillName = sessionStorage.getItem("skillName");
                        disp.meta00 = agentIdValue;
                        disp.meta01 = skillName;
                        disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                    } else {
                        disp.meta00 = agentId;
                        disp.meta01 = teamName;
                        disp.dial_list_uid = state$.value.choosecaller?.callId;
                    }
                    disp.meta02 = statusvalue[1];
                    disp.meta03 = 'client';
                    actions.push(pushToDisposition(disp));
                }
              }

              if(value && value?.length > 0 && value[0].includes('getactiveallergies')){
                if (statuscode !== "true200") {
                    let disp: Disposition = { value: "981" }
                    if (contact_center_type && contact_center_type === 'five9') {
                        let agentIdValue = sessionStorage.getItem("agentName");
                        let skillName = sessionStorage.getItem("skillName");
                        disp.meta00 = agentIdValue;
                        disp.meta01 = skillName;
                        disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                    } else {
                        disp.meta00 = agentId;
                        disp.meta01 = teamName;
                        disp.dial_list_uid = state$.value.choosecaller?.callId;
                    }
                    disp.meta02 = statusvalue[1];
                    disp.meta03 = 'client';
                    actions.push(pushToDisposition(disp));
                }
              }

              if(value && value?.length > 0 && value[0].includes('getactiveproblemlist')){
                if (statuscode !== "true200") {
                    let disp: Disposition = { value: "982" }
                    if (contact_center_type && contact_center_type === 'five9') {
                        let agentIdValue = sessionStorage.getItem("agentName");
                        let skillName = sessionStorage.getItem("skillName");
                        disp.meta00 = agentIdValue;
                        disp.meta01 = skillName;
                        disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                    } else {
                        disp.meta00 = agentId;
                        disp.meta01 = teamName;
                        disp.dial_list_uid = state$.value.choosecaller?.callId;
                    }
                    disp.meta02 = statusvalue[1];
                    disp.meta03 = 'client';
                    actions.push(pushToDisposition(disp));
                }
              }

              if(value && value?.length > 0 && value[0].includes('getmedicalhistory')){
                if (statuscode !== "true200") {
                    let disp: Disposition = { value: "983" }
                    if (contact_center_type && contact_center_type === 'five9') {
                        let agentIdValue = sessionStorage.getItem("agentName");
                        let skillName = sessionStorage.getItem("skillName");
                        disp.meta00 = agentIdValue;
                        disp.meta01 = skillName;
                        disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                    } else {
                        disp.meta00 = agentId;
                        disp.meta01 = teamName;
                        disp.dial_list_uid = state$.value.choosecaller?.callId;
                    }
                    disp.meta02 = statusvalue[1];
                    disp.meta03 = 'client';
                    actions.push(pushToDisposition(disp));
                }
              }

              if(value && value?.length > 0 && value[0].includes('getpatientbillingdetails')){
                if (statuscode !== "true200") {
                    let disp: Disposition = { value: "984" }
                    if (contact_center_type && contact_center_type === 'five9') {
                        let agentIdValue = sessionStorage.getItem("agentName");
                        let skillName = sessionStorage.getItem("skillName");
                        disp.meta00 = agentIdValue;
                        disp.meta01 = skillName;
                        disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                    } else {
                        disp.meta00 = agentId;
                        disp.meta01 = teamName;
                        disp.dial_list_uid = state$.value.choosecaller?.callId;
                    }
                    disp.meta02 = statusvalue[1];
                    disp.meta03 = 'client';
                    actions.push(pushToDisposition(disp));
                }
              }

              if(value && value?.length > 0 && value[0].includes('getmedication')){
                if (statuscode !== "true200") {
                    let disp: Disposition = { value: "985" }
                    if (contact_center_type && contact_center_type === 'five9') {
                        let agentIdValue = sessionStorage.getItem("agentName");
                        let skillName = sessionStorage.getItem("skillName");
                        disp.meta00 = agentIdValue;
                        disp.meta01 = skillName;
                        disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                    } else {
                        disp.meta00 = agentId;
                        disp.meta01 = teamName;
                        disp.dial_list_uid = state$.value.choosecaller?.callId;
                    }
                    disp.meta02 = statusvalue[1];
                    disp.meta03 = 'client';
                    actions.push(pushToDisposition(disp));
                }
              }

              if(value && value?.length > 0 && value[0].includes('getcoveragebuckets')){
                if (statuscode !== "true200") {
                    let disp: Disposition = { value: "986" }
                    if (contact_center_type && contact_center_type === 'five9') {
                        let agentIdValue = sessionStorage.getItem("agentName");
                        let skillName = sessionStorage.getItem("skillName");
                        disp.meta00 = agentIdValue;
                        disp.meta01 = skillName;
                        disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                    } else {
                        disp.meta00 = agentId;
                        disp.meta01 = teamName;
                        disp.dial_list_uid = state$.value.choosecaller?.callId;
                    }
                    disp.meta02 = statusvalue[1];
                    disp.meta03 = 'client';
                    actions.push(pushToDisposition(disp));
                }
              }
          })

          return actions;
        })
      );
    })
  );
};
